import hotelOffersData from './hotelOffers.json';

export interface HotelOffer {
  productId: number;
  hotelId: number;
  tag: string;
  amount: string | null;
}

export interface HotelOfferTag {
  title: string;
  shortTitle: string;
  lineItemTitle: string;
  description: string;
}

export const hotelOffers: HotelOffer[] = hotelOffersData;

export type HotelOfferKey = keyof typeof hotelOffersTags;

export const hotelOffersTags: Record<string, HotelOfferTag> = {
  'F&B Credit': {
    title: '[[AMOUNT]] food & beverage credit included',
    shortTitle: '[[AMOUNT]] F&B Credit',
    lineItemTitle: '[[AMOUNT]] F&B Credit',
    description:
      'Enjoy [[AMOUNT]] in food and beverage credit with each purchase. Valid for booked visit date.',
  },
  Cocktails: {
    title: 'Cocktail included',
    shortTitle: 'Cocktail Incl.',
    lineItemTitle: 'Cocktail',
    description:
      'Enjoy a complimentary cocktail, mocktail, or specialty drink with your booking. See product description for full details.',
  },
  Champagne: {
    title: 'Champagne included',
    shortTitle: 'Champagne Incl.',
    lineItemTitle: 'Champagne',
    description:
      'Enjoy champagne, prosecco, or wine with your booking. See product description for full details.',
  },
  'All-Inclusive': {
    title: 'Food & beverage included',
    shortTitle: 'F&B All-Inclusive',
    lineItemTitle: 'Food & Beverage',
    description:
      'Enjoy complimentary food and beverages for the entire day. Valid for booked visit date. ',
  },
  'Conditional F&B Credit': {
    title: 'Food & beverage credit included',
    shortTitle: 'F&B Credit',
    lineItemTitle: 'F&B Credit',
    description:
      'Enjoy food and beverage credit with each purchase. See product description for details. Valid for booked visit date.',
  },
};
